import { render, staticRenderFns } from "./index.vue?vue&type=template&id=11dd9b79&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dd9b79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11dd9b79')) {
      api.createRecord('11dd9b79', component.options)
    } else {
      api.reload('11dd9b79', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=11dd9b79&scoped=true&", function () {
      api.rerender('11dd9b79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/goods/goodsOrder/index.vue"
export default component.exports